import { HttpRequest } from '@angular/common/http';

export function buildSingleFlightKey(req: HttpRequest<unknown>): string {
  return [req.method, req.urlWithParams, serializeBody(req.body)].join('|');
}

function serializeBody(body: unknown): string {
  if (body === null || body === undefined) {
    return '';
  }
  if (body instanceof FormData) {
    return '[FormData]';
  }
  if (body instanceof ArrayBuffer) {
    return '[ArrayBuffer]';
  }
  if (body instanceof Blob) {
    return '[Blob]';
  }
  if (body instanceof URLSearchParams) {
    return body.toString();
  }
  if (typeof body === 'object') {
    return JSON.stringify(sortObjectKeys(body as Record<string, unknown>));
  }
  return String(body);
}

function sortObjectKeys(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(sortObjectKeys);
  }
  if (value !== null && typeof value === 'object') {
    return Object.keys(value as Record<string, unknown>)
      .sort()
      .reduce<Record<string, unknown>>((acc, key) => {
        acc[key] = sortObjectKeys((value as Record<string, unknown>)[key]);
        return acc;
      }, {});
  }
  return value;
}
